import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import backArrowIcon from '../../assets/img/back-arrow.png';
import { API_URL } from '../../utils/constant';
import exportIcon from '../../assets/icon/icon-export-excel.svg';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { Pagination } from '../../components/Pagination';

const LIMIT = 20;

const OfficeUserReport = () => {
    const backPath = '/report/list';
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [roles, setRoles] = useState([]);

    const getRoleName = (roleId) => {
        return roles.find((role) => role.role_id === roleId)?.role_name || '';
    };

    const fetchOfficeUsers = (targetPage = 1, targetLimit = LIMIT) => {
        const url = API_URL + `/user?status=ACTIVE&page=${targetPage}&limit=${targetLimit}`;

        return axios
            .get(url, {
                withCredentials: true,
            })
            .then((response) => {
                setData(response.data.data || []);
                setTotalCount(response.data.totalCount || 0);
            })
            .catch((e) => {
                console.log(e.response);
            });
    };

    useEffect(() => {
        axios
            .get(API_URL + '/role?sort=role_level', {
                withCredentials: true,
            })
            .then((response) => {
                setRoles(response.data.data || []);
            })
            .catch((e) => {
                console.log(e.response);
            });
    }, []);

    useEffect(() => {
        fetchOfficeUsers(page, LIMIT);
    }, [page]);

    const handleExportClick = async (fileName) => {
        try {
            const response = await axios.get(
                API_URL + `/user?status=ACTIVE&page=1&limit=100000`,
                {
                    withCredentials: true,
                }
            );

            const exportRows = (response.data.data || []).map((item) => ({
                Name: item.name || '',
                'User Name': item.username || '',
                'User Role': getRoleName(item.role_id),
                'Phone No': item.phone || item.phone1 || '',
            }));

            const worksheet = XLSX.utils.json_to_sheet(exportRows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Office Users');
            XLSX.writeFile(workbook, fileName);
        } catch (e) {
            console.log(e.response);
        }
    };

    return (
        <div className='sub-page-layout-1'>
            <div className='container' style={{ height: 'auto' }}>
                <div className="report-page-header text-3xl">
                    <div className="report-page-heading">
                        <Link className='back-to-page' to={backPath}>
                            <img src={backArrowIcon} />
                            Back
                        </Link>
                        <h1 className='sub-page-title'>Office User Report</h1>
                    </div>

                    <div className="report-toolbar">
                        <button
                            className="gold-btn report-export-button"
                            onClick={() => handleExportClick('Office_User_Report.xlsx')}
                        >
                            <img src={exportIcon} alt="export excel icon" />
                            <span>Export Excel</span>
                        </button>
                    </div>
                </div>
                <div className="table-container">
                    <table className="x-table" id="xlsx-export">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>User Name</th>
                                <th>User Role</th>
                                <th>Phone No</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.map((item) => {
                                return (
                                    <tr key={item.user_id}>
                                        <td>{item.name}</td>
                                        <td>{item.username}</td>
                                        <td>{getRoleName(item.role_id)}</td>
                                        <td>{item.phone || item.phone1}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="w-full flex justify-end mt-4">
                    <Pagination
                        page={page}
                        totalCount={totalCount}
                        limit={LIMIT}
                        onChange={setPage}
                    />
                </div>
            </div>
        </div>
    );
}
 
export default OfficeUserReport;
